module.exports = {
          srcSet: __webpack_public_path__ + "ef6865b42510314849e843b4637fed05-259.png"+" 259w",
          images:[ {path: __webpack_public_path__ + "ef6865b42510314849e843b4637fed05-259.png",width: 259,height: 223}],
          src: __webpack_public_path__ + "ef6865b42510314849e843b4637fed05-259.png",
          toString:function(){return __webpack_public_path__ + "ef6865b42510314849e843b4637fed05-259.png"},
          
          width: 259,
          height: 223
        }